<template>
  <div class="modal-form">
    <div
      class="modal-form-bg"
      @click="$router.push({ query: {} }).catch(() => {}), $emit('cancel')"
    ></div>

    <div class="modal-form-card">
      <div class="modal-card-header">
        <h3>ເພີ່ມບໍລິສັດແບັກລິສ</h3>

        <div class="modal-card-header-end">
          <div class="buttons">
            <button
              class="button grey"
              @click="
                $router.push({ query: {} }).catch(() => {}), $emit('cancel')
              "
            >
              ຍົກເລີກ
            </button>

            <button
              :class="['button primary', { 'is-loading': isLoading }]"
              v-if="!status && !$route.query.status"
              @click.prevent="blacklistCompany()"
            >
              ບັນທຶກ
            </button>
            <button
              :class="['button primary', { 'is-loading': isLoading }]"
              v-else-if="!status && $route.query.status === 'edit'"
              @click.prevent="updateblacklistCompany()"
            >
              ບັນທຶກ
            </button>

            <button
              :class="['button primary', { 'is-loading': isLoading }]"
              v-else
              @click.prevent="unBlacklistCompany()"
            >
              ບັນທຶກ
            </button>
          </div>
        </div>
      </div>

      <div class="modal-card-body">
        <div class="field">
          <label class="label">ເລືອກບໍລິສັດ</label>

          <div class="control">
            <div class="select-company" @click="search = true">
              <span v-if="!getSelectedCompany" class="placeholder">
                Select Company
              </span>

              <p @click="search = true" class="selected-company">
                {{ getSelectedCompany ? getSelectedCompany.companyName : "" }}
              </p>

              <input type="text" v-model="employerId" hidden="hidden" />
            </div>

            <div
              class="seach-box"
              v-if="search"
              v-click-outside="() => chooseCompany()"
            >
              <span class="search-box-title">
                <span style="color: white">Please select the company</span>

                <span @click="search = false">
                  <i
                    style="color: white"
                    class="far fa-times-circle close-btn"
                  ></i>
                </span>
              </span>

              <div class="search">
                <input
                  v-model="searchText"
                  type="text"
                  class="input"
                  placeholder="Company name"
                />
              </div>

              <div class="search-list">
                <div
                  @click="chooseCompany(c._id, index)"
                  class="search-item"
                  v-for="(c, index) in getFilteredCompany"
                  :key="index"
                >
                  <p>{{ c.companyName }}</p>
                </div>
              </div>
            </div>

            <p v-if="msg" style="color: red" class="msg">{{ msg }}</p>

            <p v-if="blackList" style="color: red" class="msg">
              {{ blacklistMessage }}
            </p>
          </div>
        </div>

        <div class="field">
          <label class="label">ເຫດຜົນທີ່ແບັກລິສ</label>

          <div class="control">
            <textarea
              class="textarea"
              v-model="reasonBlacklist"
              id=""
              cols="30"
              rows="3"
              placeholder="ເຫດຜົນທີ່ແບັກລິສ"
            ></textarea>
          </div>
          <p v-if="reasonErrorMessage" style="color: red" class="msg">
            {{ reasonErrorMessage }}
          </p>
        </div>
        <!-- <button class="button cancel" :class="{ info: cancelBlacklist }"
          @click="(cancelBlacklist = !cancelBlacklist), (status = !status)">
          ຍົກເລີກແບັກລິສ
        </button> -->

        <div
          class="field"
          v-if="$route.query.id && $route.query.status === 'unblacklist'"
        >
          <label class="label">ເຫດຜົນທີ່ຍົກເລີກແບັກລິສ</label>

          <div class="control">
            <textarea
              class="textarea"
              v-model="reasonUnblacklist"
              id=""
              cols="30"
              rows="3"
              placeholder="ເຫດຜົນທີ່ຍົກເລີກແບັກລິສ"
            ></textarea>
          </div>
        </div>
        <p v-if="reasonErrorMessage1" style="color: red" class="msg">
          {{ reasonErrorMessage1 }}
        </p>
        <div class="control">
          <supportImage v-model="files" :fileImage="files" />
          <p v-if="fileError" style="color: red" class="msg">{{ fileError }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apolloClient } from "@/services/apollo-client";
import { getEmployersApi } from "@/apis/employer-api";
import vClickOutside from "v-click-outside";
import supportImage from "@/components/Blacklist/supportImage.vue";
import {
  BLACKLIST_EMPLOYER,
  UPDATE_BLACKLIST_EMPLOYER,
  UNBLACKLIST_EMPLOYER,
  GETBYID,
} from "@/graphql/blacklist/blacklist";
export default {
  components: { supportImage },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  data: () => ({
    cancelBlacklist: false,
    status: false,
    employerId: "",
    companies: [],
    searchText: "",
    search: false,
    isLoading: false,
    reasonBlacklist: "",
    reasonUnblacklist: "",
    msg: "",
    reasonErrorMessage: "",
    reasonErrorMessage1: "",
    blackList: false,
    blacklistMessage: "ບໍລິສັດນີ້ຖືກແບັກລິສຢູ່...!",
    files: [],
    fileError: "",
  }),
  computed: {
    getSelectedCompany() {
      return this.companies.find((i) => {
        return i._id === this.employerId;
      });
    },
    getFilteredCompany() {
      return this.companies.filter((i) => {
        return i.companyName.toLowerCase().match(this.searchText.toLowerCase());
      });
    },
  },
  methods: {
    chooseCompany(companyId) {
      this.search = false;
      this.employerId = companyId;
      const company = this.companies.find((i) => i._id === companyId);
      this.blackList = company.blacklist;
      this.msg = "";
    },
    async fetchCompany() {
      const companies = await getEmployersApi();
      this.companies = companies;
    },
    async blacklistCompany() {
      if (!this.employerId) return (this.msg = "ກະລຸນາເລືອກບໍລິສັດກ່ອນ...!");
      if (this.blackList)
        return (this.blacklistMessage = "ບໍລິສັດນີ້ຖືກແບັກລິສຢູ່...!");
      if (!this.reasonBlacklist)
        return (this.reasonErrorMessage = "ກະລຸນາໃສ່ເຫດຜົນທີ່ແບັກລິສ");
      if (!this.files.length)
        return (this.fileError = "ກະລຸນາອັບໂຫຼດຫຼັກຖານກ່ອນ...!");
      this.isLoading = true;
      const form = {
        employerId: this.employerId,
        reasonBlacklist: this.reasonBlacklist,
        files: this.files,
      };
      await apolloClient
        .mutate({
          mutation: BLACKLIST_EMPLOYER,
          variables: form,
        })
        .then((res) => {
          if (res) {
            setTimeout(() => {
              this.isLoading = false;
              this.msg = "";
              this.reasonBlacklist = "";
              this.$emit("cancel");
            }, 1000);
          }
        })
        .catch((e) => {
          if (e) {
            this.isLoading = false;
            this.err = "Can not add to blacklist";
          }
        });
    },
    async unBlacklistCompany() {
      if (!this.employerId) return (this.msg = "ກະລຸນາເລືອກບໍລິສັດກ່ອນ...!");
      if (!this.reasonUnblacklist)
        return (this.reasonErrorMessage1 =
          "ກະລຸນາໃສ່ເຫດຜົນທີ່ຍົກເລີກແບັກລິສກ່ອນ...!");
      if (!this.files.length)
        return (this.fileError = "ກະລຸນາອັບໂຫຼດຫຼັກຖານກ່ອນ...!");
      this.isLoading = true;
      const id = this.$route.query.id;
      const form = {
        _id: id,
        employerId: this.employerId,
        reasonUnblacklist: this.reasonUnblacklist,
        files: this.files,
      };
      await apolloClient
        .mutate({
          mutation: UNBLACKLIST_EMPLOYER,
          variables: form,
        })
        .then((res) => {
          if (res) {
            setTimeout(() => {
              this.isLoading = false;
              this.$emit("cancel");
              this.msg = "";
              this.reasonUnblacklist = "";
              this.$router.push({ query: {} }).catch(() => {});
            }, 1500);
          }
        })
        .catch((e) => {
          if (e) {
            this.isLoading = false;
            this.err = "Can not add to blacklist";
          }
        });
    },
    async updateblacklistCompany() {
      if (!this.employerId) return (this.msg = "ກະລຸນາເລືອກບໍລິສັດກ່ອນ...!");
      if (!this.files.length)
        return (this.fileError = "ກະລຸນາອັບໂຫຼດຫຼັກຖານກ່ອນ...!");
      this.isLoading = true;
      const id = this.$route.query.id;
      const form = {
        _id: id,
        employerId: this.employerId,
        reasonBlacklist: this.reasonBlacklist,
        files: this.files,
      };
      await apolloClient
        .mutate({
          mutation: UPDATE_BLACKLIST_EMPLOYER,
          variables: form,
        })
        .then((res) => {
          if (res) {
            setTimeout(() => {
              this.isLoading = false;
              this.msg = "";
              this.reasonBlacklist = "";
              this.$router.push({ query: {} }).catch(() => {});
              this.$emit("cancel");
            }, 1000);
          }
        })
        .catch((e) => {
          if (e) {
            this.isLoading = false;
            this.err = "Can not add to blacklist";
          }
        });
    },
    async getbyId() {
      const id = this.$route.query.id;
      const isUnblacklist = this.$route.query.status;
      if (!id) return;
      const form = {
        _id: id,
      };
      const res = await apolloClient.query({
        query: GETBYID,
        variables: form,
      });
      const i = res.data.getById;
      this.employerId = i.employerId;
      this.reasonBlacklist = i.reasonBlacklist;
      this.reasonUnblacklist = i.reasonUnblacklist;
      this.files = i.files;
      if (isUnblacklist === "unblacklist") this.status = true;
    },
  },
  async created() {
    this.fetchCompany();
    this.getbyId();
  },
};
</script>

<style lang="scss" scoped>
.modal-form {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 999;

  .modal-form-bg {
    background-color: rgba(#000, 0.5);
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    cursor: pointer;
  }

  .modal-form-card {
    background-color: #fff;
    z-index: 8;
    position: absolute;
    left: 200px;
    right: 0;
    bottom: 0;
    top: 0;

    .modal-card-header {
      padding: 20px 30px;
      border-bottom: 1px solid var(--border-color);
      display: flex;
      align-items: center;
      z-index: 2;

      .modal-card-header-end {
        margin-left: auto;
      }

      .close {
        width: 30px;
        height: 90px;
        margin-right: 10px;
        background-color: var(--alert-color);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        i {
          color: #fff;
        }
      }

      h3 {
        font-weight: 700;
        font-size: var(--xlg-font);
        margin-bottom: 0;
      }
    }

    .modal-card-body {
      padding: 30px;
      height: 100%;

      button.cancel {
        background-color: var(--light-grey-color);
        margin: 10px 0 20px 0;
      }

      .select-company {
        display: flex;
        background-color: var(--light-grey-color);
        // position: absolute;
        border: 1px solid var(--border-color);
        height: 2.5rem;
        display: flex;
        align-items: center;
        padding-left: 10px;
        padding-left: 10px;
        z-index: 99;
        width: 100%;
        cursor: pointer;
        margin: 0;
        font-size: 16px;
        transition: all ease-in-out 0.2s;
        font-weight: 500;

        .placeholder {
          color: #000;

          &.error {
            color: var(--alert-color);
          }
        }

        .selected-company {
          font-weight: 700;
          margin-bottom: 0;
          color: var(--primary-color);
        }
      }

      .seach-box {
        z-index: 999;
        position: relative;
        padding-top: 12px;
        top: 0;
        left: 0;
        width: 50%;
        border-radius: 5px;
        background-color: var(--primary-color);
        box-shadow: 0 0px 20px 5px rgba(var(--grey-color), 0.5);
        position: absolute;

        .close-btn {
          margin-left: auto;
          cursor: pointer;
        }

        .search-box-title {
          padding: 0 20px;
          display: flex;
          justify-content: space-between;

          &:hover {
            color: inherit;
          }
        }

        .search {
          padding: 10px 20px 20px;

          input {
            background-color: var(--light-grey-color);
            box-shadow: none;
            box-shadow: unset;
            border: none;
            box-shadow: 0px 0px 0px 2px rgba(var(--primary-color), 1);
          }
        }

        .search-list {
          border: 1px solid var(--border-color);
          background-color: #fff;
          padding: 20px;
          padding: 0;
          display: block;
          height: 280px;
          overflow-y: scroll;

          .search-item {
            font-size: 14px;
            white-space: pre-line;
            margin: 0;
            padding: 10px 20px;
            transition: all ease-in-out 0.1s;
            cursor: pointer;

            &:not(:last-child) {
              border-bottom: 1px solid var(--border-color);
            }

            &:hover {
              background-color: #dbdbdb;
            }

            p {
              margin: 0;
            }
          }
        }
      }

      // search-box

      .msg {
        margin-top: 8px;
      }
    }
  }
}
</style>
